import { Button, Dropdown, Flex, MenuProps, Typography } from 'antd';
import { FC } from 'react';
import { ExclamationTriangleFill, PencilSquare, ThreeDotsVertical, Trash } from 'react-bootstrap-icons';

import { AppModal } from '@/common/components';
import { useAppModalControls } from '@/common/hooks';

interface Props {
  isItemsDisabled: boolean;
  isDeleteCloudflareAccountLoading: boolean;
  handleEditCloudflareAccount: () => void;
  handleDeleteCloudflareAccount: () => void;
}

export const CloudflareAccountsOverviewDropdown: FC<Props> = ({
  isItemsDisabled,
  isDeleteCloudflareAccountLoading,
  handleEditCloudflareAccount,
  handleDeleteCloudflareAccount
}) => {
  const [modalControls] = useAppModalControls();

  const items: MenuProps['items'] = [
    {
      key: 'edit',
      icon: <PencilSquare/>,
      label: 'Редагувати',
      disabled: isItemsDisabled,
      onClick: handleEditCloudflareAccount,
    },
    {
      key: 'divider',
      type: 'divider',
    },
    {
      key: 'delete',
      disabled: isItemsDisabled,
      danger: true,
      icon: <Trash/>,
      onClick: modalControls.open,
      label: 'Видалити',
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} placement="bottomRight" arrow={{ pointAtCenter: true }} trigger={ ['click'] }>
        <Button icon={ <ThreeDotsVertical/> }/>
      </Dropdown>

      <AppModal
        width={ 400 }
        okText="Видалити"
        okButtonProps={{ danger: true, loading: isDeleteCloudflareAccountLoading }}
        cancelButtonProps={{ disabled: isDeleteCloudflareAccountLoading }}
        onOk={ handleDeleteCloudflareAccount }
        maskClosable={ !isDeleteCloudflareAccountLoading }
        title={
          <Flex align="center">
            <Typography.Text type="danger">
              <Flex align="center">
                <ExclamationTriangleFill size={ 24 }/>
              </Flex>
            </Typography.Text>&nbsp;&nbsp;&nbsp;Видалити акаунт?
          </Flex>
        }
        controls={ modalControls }
        closable={ false }
      />
    </>
  );
};
